<!-- eslint-disable vue/multi-word-component-names -->
<!-- no-mutating-props: form/consent are reactive MODEL objects owned by the
     core GateBlock; presentational SFCs cannot hold state. -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  gate: {
    title?: string;
    sub_title?: string;
    description?: string;
    namePlaceholder?: string;
    emailPlaceholder?: string;
    nameError?: string;
    emailError?: string;
    usePhone?: boolean;
    useEmail?: boolean;
    cta?: string;
    loading?: string;
    consent_checkbox?: { text: string; required?: boolean };
  };
  quiz: { skip?: boolean; skip_cta?: string };
  form: { name: string; email: string; phone?: string };
  consent: { checked: boolean };
  fetching: boolean;
}>();
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <div class="tpl-htk__gate">
    <h2 class="tpl-htk__gate-title">{{ gate.title }}</h2>
    <p v-if="gate.description" class="tpl-htk__gate-desc">{{ gate.description }}</p>
    <form class="tpl-htk__gate-form" @submit.prevent="$emit('submit')">
      <input
        type="text" name="name" class="tpl-htk__input"
        :placeholder="gate.namePlaceholder" :title="gate.nameError"
        required minlength="3" v-model="form.name"
      />
      <input
        v-if="gate.usePhone" type="tel" name="phone" class="tpl-htk__input"
        placeholder="Phone" required v-model="form.phone"
      />
      <input
        v-if="gate.useEmail" type="email" name="email" class="tpl-htk__input"
        :placeholder="gate.emailPlaceholder" :title="gate.emailError"
        required pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" v-model="form.email"
      />
      <label v-if="gate.consent_checkbox" class="tpl-htk__consent">
        <input type="checkbox" name="consent" :required="gate.consent_checkbox.required !== false" v-model="consent.checked" />
        <span>{{ gate.consent_checkbox.text }}</span>
      </label>
      <button type="submit" class="tpl-htk__cta" :disabled="fetching">
        <span v-if="!fetching">{{ gate.cta }}</span>
        <span v-else>{{ gate.loading || '...' }}</span>
      </button>
      <button
        v-if="quiz.skip && quiz.skip_cta" type="button" class="tpl-htk__skip"
        :disabled="fetching" @click="$emit('skip')"
      >
        {{ quiz.skip_cta }}
      </button>
    </form>
  </div>
</template>
